// extracted by mini-css-extract-plugin
export var table = "_xa-0";